import React, { useState, useRef, useEffect } from "react";
import { IonApp, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonPage, IonRadio, IonRadioGroup, IonTitle, IonToolbar } from '@ionic/react';
import topics from "../../../menus/Nursery/Fruit";

const Fruits: React.FC = () => {

    const handleSubmit = (url: string) => {
        window.location.href = url;
    }

    useEffect(() => {
        document.title = "Mamas Guidance - Nursery - Environment Science - Fruit"; // Set page title
    }, []);

    return (
        <div className={`my-topic-container`}>
            {topics.map((slide, index) => (
                <IonItem key={index} routerLink={slide.url}
                    routerDirection="none"
                    lines="none"
                    detail={true}>
                    <IonLabel>{slide.title}</IonLabel>
                </IonItem>
            ))}
        </div>
    );
};
export default Fruits;